import React, { Component } from 'react';
import { Table, Button, Alert, Spinner  } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Card, CardHeader, CardBody, Row, Col, Collapse, Input } from 'reactstrap';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { AiOutlineSearch, AiOutlineReload } from 'react-icons/ai';
import { FaEdit, FaPlus, FaTrashAlt } from 'react-icons/fa';
import { withRouter } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
/*import history from "../history";*/
import './NavMenu.css';
import url from "./variables/url.js";
import { AppContext } from '../AppContext';
import Paginacion from './Paginacion';
import ActividadCard from './ActividadCard';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;


export class GestionActividad extends Component {
    static displayName = GestionActividad.name;

    constructor(props) {
        super(props);
        this.state = {
            status: 0,
            page: 1,
            buscar: '',
            buscarCategoria: 1,
            buscarTipo: 1,
            loading: true,
            loadingItem: true,
            activeTab: 1,
            collapse: 1,
            idestudiante: 0,
            actividades: [],
            categorias: [],
            tipos: [],
            iduser: 0,
            roles: [],
            currentActividades: [], currentPage: null, totalPages: null,
            pestanias: [{id: 1, nombre: 'Estudiante' },{ id: 2, nombre: 'Categoria' },{ id: 3, nombre: 'Tipo Actividad' }],
            estados: [{ id: 'I', nombre: 'En Revisi�n' }, { id: 'R', nombre: 'Rechazadas' }, { id: 'A', nombre: 'Aprobadas' }, { id: 'D', nombre: 'Devueltas' }],
            buscarEstado: 'I',
            totalPageA: 0,
            actualPage: 1,
            limite: 10,
            siblingCount: 1,            
        };

        this.handleEdit = this.handleEdit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleCard = this.toggleCard.bind(this);        
        this.searchById = this.searchById.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.onChangeCategoria = this.onChangeCategoria.bind(this);
        this.onChangeTipo = this.onChangeTipo.bind(this);
        this.actualizarActividades = this.actualizarActividades.bind(this);
        this.onChangeLimite = this.onChangeLimite.bind(this);
        if (this.props.location.state)
         this.actualizarActividades(this.props.location.state.actividad)
    }

    componentDidMount() {
        this.populateInfoData();
        this.populateActividades();
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    componentDidUpdate() {
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    isForbidden() {
        this.props.history.push({
            pathname: homepage,
        })
    }

    page(num) {
        if (this.state.actualPage !== num) {
            this.setState({
                actualPage: num
            });
        }
    }

    pagePrevious() {
        if (this.state.actualPage !== 1) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p - 1
            });
        }
    }

    pageNext() {
        if (this.state.actualPage !== this.state.totalPageA) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p + 1
            });
        }
    }

    youAreMySibling(num) {
        let actualPage = this.state.actualPage;
        let sibling = this.state.siblingCount;
        let total = this.state.totalPageA;
        let valor = false;
        if (num === actualPage || num - sibling === actualPage || num + sibling === actualPage) {
            valor = true;
        }
        if (actualPage === 1 && (num - 1 === actualPage || num - 2 === actualPage || num - 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === 2 && (num - 1 === actualPage || num - 2 === actualPage)) {
            valor = true;
        }
        if (actualPage === total && (num + 1 === actualPage || num + 2 === actualPage || num + 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === total - 1 && (num + 1 === actualPage || num + 2 === actualPage)) {
            valor = true;
        }
        //console.log(num, valor);
        return valor;
    }

    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageA: Math.ceil(lenActividades / limite), actualPage: 1 });
                
    }

    actualizarActividades(actividad) {
        let actividades = this.state.actividades;
        let indice = actividades.indexOf(actividad);
        actividades[indice] = actividad;
        this.setState({ actividades: actividades });
    }

    onChangeLimite(event) {
        //console.log('Cambio limite');
        //console.log(event.target.value);
        var num = event.target.value;
        this.setState({ limite: num });
        this.reLoadTotalPage(this.state.actividades.length, num);
    }

    miEstado(est) {
        let estado = 'En Revisi\u00F3n';
        if (est == 'A') {
            estado = 'Aprobado';
        } else if (est == 'R') {
            estado = 'Rechazado';
        } else if (est == 'D') {
            estado = 'Devuelto';
        }
        return estado;
    }

    componentWillReceiveProps(nextProps) {
        //console.log('componentWillReceiveProps', nextProps);
        this.setState(nextProps);
    }

    onPageChanged = data => {
        const { actividades } = this.state;
        const { currentPage, totalPages, pageLimit } = data;
        const offset = (currentPage - 1) * pageLimit;
        const currentActividades = actividades.slice(offset, offset + pageLimit);

        this.setState({ currentPage, currentActividades, totalPages });
    }    

    renderGestionTable(actividades, categorias, tipos) {
        const { collapse } = this.state;
        const { currentActividades, currentPage, totalPages } = this.state;
        const totalAct = actividades.length;
        const limite = 10;
        const vecindario = 1;                
    return (
      <div>           
            <Nav pills>
                {this.state.pestanias.map(pes =>
                    <NavItem>
                        <NavLink className="icon-pointer" active={pes.id === this.state.activeTab} onClick={() => { this.toggle(pes.id); }}>
                            {pes.nombre}
                        </NavLink>
                    </NavItem>
                )}
            </Nav>
            <hr />
            <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId={1}>
                    <Row>                        
                        <InputGroup className="col-md-6">
                            <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                        <Input placeholder="20210..." onChange={this.handleSearch} value={this.state.buscar} />
                        <InputGroupAddon addonType="append">
                            <InputGroupText onClick={() => this.searchById()}>
                                <AiOutlineSearch />
                            </InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </Row>
                    <hr />                    
                </TabPane>
                <TabPane tabId={2}>
                    <Row>                      
                        <InputGroup className="col-md-6">
                            <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                        <Input className="form-control" type="select" onChange={this.onChangeCategoria} >
                            {categorias.map(insignia =>
                                <option key={insignia.idaexinsignia}  value={insignia.idaexinsignia}>{insignia.nombre}</option>
                            )
                            }
                        </Input>
                        <InputGroupAddon addonType="append">
                            <InputGroupText onClick={() => this.searchByCategoria()}>
                                <AiOutlineSearch />
                            </InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </Row>
                    <hr />
                </TabPane>
                <TabPane tabId={3}>
                    <Row>                    
                        <InputGroup className="col-md-6">
                            <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                        <Input className="form-control" type="select" onChange={this.onChangeTipo} >
                            {tipos.map(tipo =>
                                <option key={tipo.idaextipoactividad} value={tipo.idaextipoactividad}>{tipo.nombre}</option>
                            )
                            }
                        </Input>
                        <InputGroupAddon addonType="append">
                            <InputGroupText onClick={() => this.searchByTipo()}>
                                <AiOutlineSearch />
                            </InputGroupText>
                        </InputGroupAddon>
                        </InputGroup>
                        </Row>
                    <hr />
                </TabPane>
            </TabContent>           
            {this.state.actividades.length > 0 ?
                <>
                    <div className="container mb-5">
                        <div className="row d-flex flex-row">
                            <div className="w-100 px-4 d-flex flex-row flex-wrap align-items-center justify-content-between">
                                <div className="d-flex flex-row align-items-center">
                                    <h2>
                                        <strong className="text-secondary">{totalAct}</strong> Actividades
                                    </h2>
                                    {currentPage && (
                                        <span className="current-page d-inline-block h-100 pl-4 text-secondary">
                                            Page <span className="font-weight-bold">{currentPage}</span> / <span className="font-weight-bold">{totalPages}</span>
                                        </span>
                                    )}
                                </div>
                                <div className="d-flex flex-row py-4 align-items-center">
                                    <Paginacion totalRecords={totalAct} pageLimit={limite} pageNeighbours={vecindario} onPageChanged={this.onPageChanged} />
                                </div>                                
                            </div>
                            <Table responsive striped>
                                <thead>
                                    <tr>
                                        <th>Actividad</th>
                                        <th>Estudiante</th>
                                        <th>Tipo</th>
                                        <th>Estado</th>
                                        <th>Acciones</th>
                                        <th>Responsable</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentActividades.map((act, i) => 
                                        
                                            < tr id={act.idaexregistroactividad} >
                                            <td>{act.nombre}</td>
                                            {act.estudiante !== null ? <td>{ act.estudiante.apellidos +' '+ act.estudiante.nombres}</td> : <td>-----</td>}
                                            <td>                                                
                                                {tipos.map(tip => {
                                                    return act.idaextipoactividad == tip.idaextipoactividad ?
                                                        <label>{tip.nombre}</label> : <></>
                                                })}
                                            </td>
                                            <td> {act.registroActividadGestion != null ? this.miEstado(act.registroActividadGestion.estado) : <>X</>} </td>
                                            <th><FaEdit className="icon-pointer" onClick={(id) => this.handleEdit(act.idaexregistroactividad)} /></th>
                                            <td>{act.registroActividadGestion != null ? <>{act.registroActividadGestion.responsable.apellidos}  {act.registroActividadGestion.responsable.nombres} </>: <>No registrado</>  } </td>
                                            </tr> 
                                    )}
                                    {actividades.length == 0 ? <tr><p className=''>No se encontraron actividades</p></tr> : null}
                                </tbody>
                             </Table>
                            
                        </div>
                    </div>
                </>
                : <>No se encontraron actividades</>}
      </div>
    );
    }

    renderGestionTable2(actividades, categorias, tipos) {
        let pagesA = [];
        for (let i = 1; i <= this.state.totalPageA; i++) {
            pagesA.push(<></>);
        }
        return (
            <div>
                <Nav pills>
                    {this.state.pestanias.map(pes =>
                        <NavItem>
                            <NavLink className="icon-pointer" active={pes.id === this.state.activeTab} onClick={() => { this.toggle(pes.id); }}>
                                {pes.nombre}
                            </NavLink>
                        </NavItem>
                    )}
                </Nav>
                <hr />
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                                <Input placeholder="20210..." onChange={this.handleSearch} value={this.state.buscar} />
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchById()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                    <TabPane tabId={2}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                                <Input className="form-control" type="select" onChange={this.onChangeCategoria} >
                                    {categorias.map(insignia =>
                                        <option key={insignia.idaexinsignia} value={insignia.idaexinsignia}>{insignia.nombre}</option>
                                    )
                                    }
                                </Input>
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchByCategoria()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                    <TabPane tabId={3}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                                <Input className="form-control" type="select" onChange={this.onChangeTipo} >
                                    {tipos.map(tipo =>
                                        <option key={tipo.idaextipoactividad} value={tipo.idaextipoactividad}>{tipo.nombre}</option>
                                    )
                                    }
                                </Input>
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchByTipo()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                </TabContent>
                {this.state.actividades.length > 0 ?
                    <>
                        <div>
                            <Row hidden={this.state.actividades.length === 0} id={'newPagination'}>                                
                                <Col xs="2">
                                    <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                                        <option hidden key={"sel-1"} selected={1 == this.state.limite} value={1}>{1}</option>
                                        <option key={"sel-5"} selected={5 == this.state.limite} value={5}>{5}</option>
                                        <option key={"sel-10"} selected={10 == this.state.limite} value={10}>{10}</option>
                                        <option key={"sel-25"} selected={25 == this.state.limite} value={25}>{25}</option>
                                        <option key={"sel-50"} selected={50 == this.state.limite} value={50}>{50}</option>
                                        <option key={"sel-100"} selected={100 == this.state.limite} value={100}>{100}</option>
                                    </Input>
                                </Col>
                                <Col>
                                    <Pagination hidden={pagesA.length < 1} >
                                        <PaginationItem active={this.state.actualPage === 1} onClick={() => { this.page(1); }}>
                                            <PaginationLink>
                                                {1}
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem hidden={this.state.totalPageA < 5 || this.state.actualPage === 1} onClick={() => { this.pagePrevious(); }}>
                                            <PaginationLink previous />
                                        </PaginationItem>
                                        {pagesA.map((page, i) =>
                                        (
                                            <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageA || !this.youAreMySibling(i + 1)} active={this.state.actualPage === i + 1} onClick={() => { this.page(i + 1); }}>
                                                <PaginationLink>
                                                    {i + 1}
                                                </PaginationLink>
                                            </PaginationItem>)
                                        )}
                                        <PaginationItem hidden={this.state.totalPageA < 5 || this.state.actualPage === this.state.totalPageA} onClick={() => { this.pageNext(); }}>
                                            <PaginationLink next />
                                        </PaginationItem>
                                        <PaginationItem hidden={this.state.totalPageA === 1} active={this.state.actualPage === this.state.totalPageA} onClick={() => { this.page(this.state.totalPageA); }}>
                                            <PaginationLink>
                                                {this.state.totalPageA}
                                            </PaginationLink>
                                        </PaginationItem>
                                    </Pagination>
                                </Col>

                            </Row>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Actividad</th>
                                        <th>Estudiante</th>
                                        <th>Competencia</th>
                                        <th>Tipo Actividad</th>
                                        <th>Estado</th>
                                        <th>Acciones</th>
                                        <th>Responsable</th>
                                    </tr>
                                </thead>
                               
                                    <tbody>
                                        {actividades.map((act, i) => {
                                            return <tr id={i} key={i} hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                                                <td>{(i + 1)}</td>
                                                <td>{act.nombre}</td>
                                                {act.estudiante !== null ? <td>{act.estudiante.apellidos + ' ' + act.estudiante.nombres}</td> : <td>-----</td>}
                                                <td>{this.state.categorias.filter(cate => cate.idaexinsignia === act.categoria).map(actcat => actcat.nombre)}</td>
                                                <td>{this.state.tipos.filter(tipo => tipo.idaextipoactividad === act.idaextipoactividad).map(acttipo => acttipo.nombre)}</td>
                                                <td> {act.registroActividadGestion != null ? this.miEstado(act.registroActividadGestion.estado) : <>X</>} </td>
                                                <th><FaEdit className="icon-pointer" onClick={(id) => this.handleEdit(act.idaexregistroactividad)} /></th>
                                                <td>{act.registroActividadGestion != null ? <>{act.registroActividadGestion.responsable.apellidos}  {act.registroActividadGestion.responsable.nombres} </> : <>No registrado</>} </td>
                                            </tr>
                                        }
                                        )}
                                    </tbody>                                   

                            </Table>
                        </div>
                    </>
                    : <><Spinner animation="grow" /></>}
            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <><Spinner animation="grow" /></>
            : this.renderGestionTable2(this.state.actividades,this.state.categorias, this.state.tipos);

        return (
            <div>                
                {contents}
            </div>
        );
    }

    populateActividades() {

        fetch(localBack + '/api/RegistroActividad/GetWithGestion', {
        //fetch(localBack + '/api/RegistroActividad/GetByEstado/I', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: []});
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {                    
                    //console.log(data.objDatos);
                    this.setState({ actividades: data.objDatos, loading: false });                    
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                } else {
                    this.setState({ actividades: [], loading: false });
                }
            });
        /*this.setState({ actividades: insig.objDatos, loading: false });*/
    }

    populateGestion() {

        fetch(localBack + '/api/RegistroActividad/GetWithGestion', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loading: false });
                } else {
                    this.setState({ actividades: [], loading: false });
                }
            });
        /*this.setState({ actividades: insig.objDatos, loading: false });*/
    }

    populateInfoData() {
        fetch(localBack + '/api/Insignia', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {
                    //console.log(data);
                    this.setState({
                        categorias: data.objDatos, loading: false,
                    });
                });

        fetch(localBack + '/api/TipoActividad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                this.setState({
                    tipos: data.objDatos                    
                });
            });        
        
    }

    newAct() {
        //console.log('Nueva Actividad');
        this.props.history.push(homepage+'Add-Act');
    }

    handleEdit(id) {
        //console.log("Editar " + id);
        this.props.history.replace(homepage+"Gestion/" + id);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            //console.log(tab);
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleCard(e) {
        let event = e.target.dataset.event;
        this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });
        //console.log(Number(event));
    }    

    handleSearch = async function(event) {
        await this.setState({ buscar: event.target.value });
        //console.log(this.state.buscar);
    }

    onChangeCategoria = async function (event) {
        //console.log('Cambio Categoria');
        //console.log(event.target.value);
        var id = event.target.value;
        await this.setState({ buscarCategoria: id });
        //console.log(this.state.buscarCategoria);        
    }


    onChangeTipo = async function(e) {
        //console.log('Cambio Tipo');
        //console.log(e.target.value);
        var id = e.target.value;
        await this.setState({ buscarTipo: id });
        //console.log(this.state.actividad);        
    }

    searchById() {
        this.setState({ loadingItem: true });

        if (this.state.buscar !== '') {
            fetch(localBack + '/api/RegistroActividad/GetByCodestudiante/' + this.state.buscar, {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => {
                    this.setState({ status: response.status, actividades: [] });
                    return response.json();
                })
                .then(data => {
                    //console.log(data.strMensaje);
                    if (data.strEstado == 'S') {
                        this.setState({ actividades: data.objDatos, loadingItem: false });
                        this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                    }
                });
            //console.log(this.state.actividades);
        } else {
            //console.log('buscar esta vacio.');
        }

        
    }

    searchByCategoria() {
        this.setState({ loadingItem: true });

        fetch(localBack + '/api/RegistroActividad/GetByCategoria/' + this.state.buscarCategoria, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: [] });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loadingItem: false });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                }
            });
        //console.log(this.state.actividades);
    }

    searchByTipo() {
        this.setState({ loadingItem: true });

        fetch(localBack + '/api/RegistroActividad/GetByTipoActividad/' + this.state.buscarTipo, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: [] });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loadingItem: false});
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                }
            });
        //console.log(this.state.actividades);
    }

}
GestionActividad.contextType = AppContext;
export default withRouter(GestionActividad);